<template>
  <AppBar />
  <v-container v-if="item">
    <v-btn variant="text" @click="$router.back()">← Назад</v-btn>

    <h1 class="mt-4 mb-4">{{ item.title }}</h1>
    <p class="mb-4">{{ item.date }}</p>

    <video
        v-if="item.video"
        class="news-video mb-6"
        :src="item.video"
        controls
        playsinline
        preload="metadata"
    ></video>

    <v-row class="mb-6" v-if="item.images">
      <v-col
          v-for="(img, index) in item.images"
          :key="index"
          cols="12"
          sm="6"
          md="4"
      >
        <v-img :src="img" aspect-ratio="1" cover />
      </v-col>
    </v-row>

    <div v-html="item.content"></div>
  </v-container>
  <Footer />
</template>

<script>
import { news } from '@/data/news'
import AppBar from "@/components/AppBar.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {Footer, AppBar},
  props: ['slug'],
  computed: {
    item() {
      return news.find(n => n.slug === this.$route.params.slug)
    }
  }
}
</script>

<style scoped lang="sass">
.news-video
  width: 100%
  max-height: 70vh
  display: block
  border-radius: 12px
  background: #000
</style>
